import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import ArticleGrid from './components/ArticleGrid';
import HotRanking from './components/HotRanking';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '吃瓜网',
    url: 'https://chiguawang.com',
    description: '专注娱乐八卦、明星爆料、热门事件的资讯聚合平台',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://chiguawang.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜网',
    url: 'https://chiguawang.com',
    description: '专注娱乐八卦、明星爆料、热门事件的资讯聚合平台',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <HeroSection />
      <CategoryNav />
      <ArticleGrid />
      <HotRanking />
      <NewsletterSection />
    </>
  );
}